// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_CURRENCY = "EUR";
export const NOT_BREAKFAST_ENTERIES = ["none", "dinner", "lunch", "room_only", "lunch_and_dinner"];
